/**
 * Web Style Import
 *
 */

import './style/dnb-table.scss'
